import {computed} from 'mobx';
import {flow, types} from 'mobx-state-tree';
import UserModel from '../models/user-model';
import UserService from 'src/services/user-service.js';

const UserStore = types
    .model('UserStore', {
        users: types.optional(types.array(UserModel), []),
    })
    .actions((self) => ({
        setUsers(users) {
            self.users = users;
        },
        addAll: (users) => self.users.push(...users),
    }))
    .actions((self) => ({
        revalidateUser: flow(function* (userId) {
            const userIndex = self.users.findIndex((user) => user.id === userId);
            if (userIndex === -1) return;

            const userService = new UserService();
            const revalidatedUser = yield userService.find(userId);
            self.users[userIndex] = revalidatedUser;
        }),
    }))
    .extend((self) => {
        // Índice por id: a lista de dispositivos procura o criador de cada linha da frota. keepAlive faz o
        // índice ficar em cache também fora de reação, como na exportação para Excel feita no clique; sem
        // isso ele seria remontado a cada chamada. O id não é identificador no modelo, então o primeiro
        // usuário com cada id vence, como na busca pela lista.
        const usersById = computed(() => {
            const map = new Map();
            for (const user of self.users) {
                if (!map.has(user.id)) map.set(user.id, user);
            }
            return map;
        }, {keepAlive: true});
        return {views: {getUserById: (id) => usersById.get().get(id)}};
    })
    .views((self) => ({
        getDrivers() {
            return self.users;
        },
        get list() {
            return self.users.toJSON();
        },
    }));

export default UserStore;

